import { instance } from 'api/api';

/** One Context row of a generation attempt; `scope` marks the access-scope row (always last). */
export interface GenerationContextRow {
    key: string;
    value: string;
    scope: boolean;
}

export interface GenerationToolCall {
    tool: string;
    request: string;
    response: string;
    status: string;
    outcome_label: string;
}

export interface GenerationResult {
    kind: 'generated' | 'fallback' | 'hidden' | 'failed';
    title: string;
    text: string;
    suggested_fix: string | null;
}

/** Generation Details payload (AI_Insights.md §7.4); every label arrives translated. */
export interface GenerationDetails {
    id: number;
    status: string;
    status_key: 'generated' | 'skipped' | 'failed';
    status_label: string;
    attempted: string;
    trigger: { type: string; label: string; burst_name: string | null; burst_url: string | null };
    user_login: string;
    insight: { id: number; name: string; edit_url: string | null };
    prompt: string;
    context_rows: GenerationContextRow[];
    returned: GenerationToolCall[];
    returned_help: string;
    returned_empty: string;
    is_conditional: boolean;
    significant: boolean | null;
    // text: the stored verdict; url: where to reconstruct it when text is null
    evaluation: { text: string | null; url: string | null };
    result: GenerationResult;
}

type Envelope<T> = { status: 'OK'; data: T } | { status: 'ERROR'; error?: string };

export const generationHistoryAPI = {
    async details(elementId: number, logId: number): Promise<GenerationDetails> {
        const response = await instance.get<Envelope<GenerationDetails>>(
            `/data/editor/element/extreport/${elementId}/generation-history/${logId}/details`,
        );
        if (response.data?.status !== 'OK') {
            throw new Error(('error' in response.data && response.data.error) || 'not_found');
        }

        return response.data.data;
    },

    /** '' when the verdict could not be reconstructed. */
    async evaluation(url: string): Promise<string> {
        const response = await instance.post<Envelope<{ evaluation: string }>>(url);

        return response.data?.status === 'OK' ? String(response.data.data?.evaluation ?? '') : '';
    },
};
